import 'babel-polyfill'
import 'whatwg-fetch'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { App } from '@app/components/App'

const el = document.getElementById('f1times')

ReactDOM.render(<App />, el)
